import * as React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export default function DeleteModal({
  openState,
  setOpen,
  contentText,
  handleDeleteSession
}) {
  const classes = useStyles();

  return (
    <>
      {openState && (
        <Box>
          <Dialog
            open={openState}
            // onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <>
              <DialogTitle id="alert-dialog-title" text="h5"></DialogTitle>
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  text="body1"
                  color="textPrimary">
                  {contentText}
                </DialogContentText>
                <DialogContentText
                  id="alert-dialog-description"
                  text="small"
                  color="textSecondary"></DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setOpen(false)}
                  size="medium"
                  state="enabled"
                  variant="text"
                  color="primary">
                  취소
                </Button>
                <Button
                  onClick={handleDeleteSession}
                  size="medium"
                  state="enabled"
                  variant="text"
                  color="secondary">
                  삭제하기
                </Button>
              </DialogActions>
            </>
          </Dialog>
        </Box>
      )}
    </>
  );
}

const useStyles = makeStyles(() => ({
  root: {
    //    padding: theme.spacing(2)
  }
}));
